import { useAtom } from 'jotai';
import { updateFlowOrderAtom } from '../../atoms';

const useDndUtils = (order: string[]) => {
  const [, updateOrder] = useAtom(updateFlowOrderAtom);

  const handleDragEnd = (event) => {
    const { active, over } = event;

    if (!over) return;

    // Convert IDs back to the format used by the order array if they're not already
    const activeId = typeof active.id === 'string' ? active.id : String(active.id);
    const overId = typeof over.id === 'string' ? over.id : String(over.id);

    const sourceIdx = order.indexOf(activeId);
    const destIdx = order.indexOf(overId);

    if (sourceIdx === -1 || destIdx === -1) {
      console.error('Drag failed: Could not find index for items', {
        activeId,
        overId,
        sourceIdx,
        destIdx,
        order,
      });
      return;
    }

    // create new order
    const newOrder = Array.from(order);
    const [reorderedItem] = newOrder.splice(sourceIdx, 1);
    newOrder.splice(destIdx, 0, reorderedItem);

    // Update order in state - persistence is handled automatically at the dashboard level
    updateOrder(newOrder);
  };

  return { handleDragEnd };
};

export default useDndUtils;
